import { ComponentChildren } from 'preact';
import { getText } from 'src/ConsentManagement/TranslationService';

type ButtonModel = {
  id?: string;
  onClick?: (evt?: Event) => void;
  translationKey?: string;
  class?: string;
  fullWidth?: boolean;
  icon?: ComponentChildren;
};

export const Button = ({
  id,
  translationKey,
  onClick,
  class: cssClass,
  fullWidth = true,
  icon = null,
}: ButtonModel) => {
  return (
    <div class="button-container">
      <div id={id} class={`privacy-prompt-button ${cssClass} ${fullWidth ? '' : 'button-collapse'}`} onClick={onClick}>
        {icon}
        <span>{getText(translationKey)}</span>
      </div>
    </div>
  );
};
